module.exports = __webpack_public_path__ + "assets/img/clerk_img01.868d0e11.png";